<template>
  <div v-show="styles_loaded" :class="setbrandid" :style="new_style_variables">
    <HeaderConfim
      :logo_link="logo_link"
      :home_link="home_link"
      :header_menu="header_menu"
      :show_basket="false"
      :show_home="true"
      :show_languages="true"
      :basket_number="0"
      :logo_image="logo_image"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></HeaderConfim>

    <div class="page-bg" :style="set_style_variables">
      <div class="confirmation-banner-container">
        <ConfirmationBanner
          :headline="getrans(brandContent.bannerHeadline)"
          :subheadline="''"
          edit-label="Edit"
        >
        </ConfirmationBanner>
      </div>

      <div
        class="page-content page-content--fullwidth"
        v-if="is_guest == 'Y' && guesttomember == 'N' && createaccount == 'N' && !is_logged_in_user"
      >
        <div class="page-content__box">
          <div class="page-content__box--box-style" style="margin-bottom: 0">
            <h3 class="page-content__box-title">
              {{ getrans(brandContent.guestTitle) }}
            </h3>
            <p style="font-size: 1.2em; color: #545454">
              {{ getrans(brandContent.guestNote) }}
            </p>

            <p style="max-width: 120ch" v-if="brandContent.privacyPolicyLabel || brandContent.privacyPolicyLink">
              <b>{{ getrans("Please note:") }}</b>&nbsp;
              <a target="_blank" :href="privacy_policy_link">
                {{ getrans(brandContent.privacyPolicyLabel || 'Privacy Policy') }}
              </a>.
            </p>

            <button
              style="width: auto; padding: 1rem 3rem"
              class="page-content__box-btn"
              @click="createaccountaction"
            >
              {{ getrans("Create Account") }}
            </button>
          </div>
        </div>
      </div>

      <div
        class="page-content page-content--fullwidth"
        v-if="createaccount == 'Y'"
      >
        <div class="page-content__box">
          <div class="page-content__box--box-style" style="margin-bottom: 0">
            <h3 class="page-content__box-title">
              {{ getrans(brandContent.accountCreatedTitle) }}
            </h3>
            <p v-if="brandContent.accountCreatedSubtitle" style="font-size: 1.2em; color: #545454">
              {{ getrans(brandContent.accountCreatedSubtitle) }}
            </p>
            <h3
              v-if="brandContent.accountCreatedButton"
              class="page-content__box-title underline"
              @click="gotoPagenewtab(my_account_link + '?lang=' + lang.toUpperCase())"
            >
              {{ getrans(brandContent.accountCreatedButton) }}
            </h3>
            <div class="account-created-box">
              <img
                class="confirmation-image"
                src="@/assets/images/confirmation_green.svg"
                alt="user image"
              />
              {{ getrans(brandContent.accountCreatedBox) }}
            </div>
          </div>
        </div>
      </div>

      <div class="page-content">
        <div class="page-content__box">
          <div
            class="page-content__box--box-style page-content__box--box-center"
          >
            <img
              class="confirmation-image"
              src="@/assets/images/confirmation.svg"
              alt="user image"
            />
            <b>{{ getrans(brandContent.confirmation.headline) }}</b>
            <p>{{ getrans(brandContent.confirmation.message) }}</p>
          </div>

          <div class="page-content__box--box-style" v-if="cartmessage">
            <h3 class="page-content__box-title">
              {{ getrans(brandContent.cartMessage.headline) }}
            </h3>
            <p>
              {{ getrans(brandContent.cartMessage.message) }}
            </p>
          </div>

          <Webloyalty hash='ef79e2723b9acf756148751f09b6bf67' ckw=''></Webloyalty>

          <div class="page-content__box" v-if="qr_data_names.length > 0">
            <div
              class="page-content__box--box-style"
              v-for="(item, i) in qr_data_names"
              :key="i"
            >
              <div class="tickets-bg-content">
                <h4 class="page-content__box-title">
                  {{ getrans(qr_product_name) }} {{ getrans("Ticket") }} - {{ getrans(item) }}
                </h4>

                <div class="table-wrapper">
                  <div class="table-wrapper--with-qr">
                    <div class="table-wrap">
                      <table>
                        <tr>
                          <td class="td-left">
                            <b>{{ getrans("Product") }}</b
                            >:&nbsp;&nbsp;
                          </td>
                          <td class="td-left">
                            {{ getrans(qr_product_name) }}
                          </td>
                        </tr>
                      </table>
                    </div>
                    <!-- break -->

                    <div class="table-wrap table-wrap-divider"></div>

                    <div class="table-wrap">
                      <table class="tickets-bg-content-mid">
                        <tr>
                          <td class="td-left">
                            <b>{{ getrans("Entry") }}</b
                            >:&nbsp;&nbsp;
                          </td>
                          <td class="td-left">
                            <i class="far fa-calendar-alt"></i>
                            {{ qr_date }} {{ qr_time }}
                          </td>
                        </tr>
                      </table>
                      <br />
                      <div
                        style="
                          display: flex;
                          width: 100%;
                          justify-content: center;
                        "
                      >
                        <a :href="qr_data_qrcodes[i]" download="image.jpg">
                          <img style="width: 120px" :src="qr_data_qrcodes[i]" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="page-content__box--box-style" v-if="cartloaded">
            <h3 class="page-content__box-title">
              <template v-if="setbrandid === 'SV1'">
                {{ getrans("Booking Summary") }}
              </template>
              <template v-else>
                {{ getrans("Your Booking Summary") }}
              </template>
            </h3>
            <div class="page-content__box-ref">
              <span>{{ getrans("Booking Reference") }}</span>
              <span
                ><b>{{ orderreference }}</b></span
              >
            </div>
            <div>
              <BasketItem
                v-if="this.cartitem !== undefined && this.showcart"
                :prop_parking_cartitem="cartitem"
                :item_price="parseFloat(cartitem.price).toFixed(2)"
                :tot_price="parseFloat(final_amount_paid).toFixed(2)"
                :item_title="cartitem.carpark_name"
                :item_start_date="formatDatedmy(cartitem.valid_from)"
                :item_start_time="cartitem.start_time"
                :item_end_date="formatDatedmy(cartitem.valid_till)"
                :item_end_time="cartitem.end_time"
                :prop_fasttrack_cartitem="fasttrack_cartitem"
                :prop_lounge_cartitem="lounge_cartitem"
                :prop_coach_cartitem="coach_cartitem"
                :lounge_total_value="lounge_total_value"
                :ftt_total_value="ftt_total_value"
                :cpk_total_value="cpk_total_value"
                :coach_total_value="coach_total_value"
                :lang="lang.toUpperCase()"
                :translations="translations"
                :brandSlug="setbrandid"
                :currency="currency"
                :final_amount_paid_tot="final_amount_paid_tot"
              />
              <BasketItem
                v-else
                :prop_fasttrack_cartitem="fasttrack_cartitem"
                :prop_lounge_cartitem="lounge_cartitem"
                :prop_coach_cartitem="coach_cartitem"
                :lounge_total_value="lounge_total_value"
                :ftt_total_value="ftt_total_value"
                :cpk_total_value="cpk_total_value"
                :coach_total_value="coach_total_value"
                :lang="lang.toUpperCase()"
                :translations="translations"
                :brandSlug="setbrandid"
                :currency="currency"
                :final_amount_paid_tot="final_amount_paid_tot"
              />
            </div>

            <div class="page-content__basket-total">
              <span
                v-if="setbrandid === 'RDU' || setbrandid === 'PV1'"
                class="page-content__box-title--total"
                ><b>{{ getrans("Amount Paid") }} :</b></span
              >
              <span v-else class="page-content__box-title--total">
                <b v-if="setbrandid === 'RDU' || setbrandid === 'PV1'"
                  >{{ getrans("Amount Paid") }} :</b
                >
                <b v-else>{{ getrans("Total") }} :</b>
              </span>
              <span class="page-content__box-title--price"
                ><b>
                  {{
                    currency_formatter(
                      parseFloat(final_amount_paid_tot).toFixed(2)
                    )
                  }}
                </b></span
              >
            </div>
          </div>
        </div>

        <div class="page-content__box">
          <h1 class="page-content__box-large-title">{{ getrans(brandContent.nextStepsSection.headline) }}</h1>
          <p v-if="brandContent.nextStepsSection.description">{{ getrans(brandContent.nextStepsSection.description) }}</p>
          <a
            v-if="brandContent.nextStepsSection.linkUrl"
            :href="brandContent.nextStepsSection.linkUrl"
            target="_blank"
            class="page-content__box-btn"
          >
            {{ getrans(brandContent.nextStepsSection.linkText) }}
          </a>

          <div
            class="page-content__box--box-style page-content__box--box-style nqy-custom-box"
          >
            <div class="page-content__box-numbered">
              <div class="page-content__box-number">1</div>
              <div class="page-content__box-number-text">
                <h3 class="page-content__box-title">
                  {{ getrans(brandContent.faqSection.questionTitle) }}
                </h3>
                <p>
                  {{ getrans(brandContent.faqSection.questionText) }}
                </p>
                <p v-if="brandContent.faqSection.reviewFaqText">
                  {{ getrans(brandContent.faqSection.reviewFaqText) }}
                </p>
                <button
                  class="page-content__box-btn"
                  @click="gotoPagenewtab(faqs_link)"
                >
                  {{ getrans(brandContent.faqSection.faqButton) }}
                </button>
              </div>
            </div>
          </div>

          <div
            class="page-content__box--box-style page-content__box--box-style nqy-custom-box"
          >
            <div class="page-content__box-numbered">
              <div class="page-content__box-number">2</div>
              <div class="page-content__box-number-text">
                <h3 class="page-content__box-title">
                  {{ getrans(brandContent.manageBooking.title) }}
                </h3>
                <p>
                  {{ getrans(brandContent.manageBooking.text) }}
                </p>
                <button
                  class="page-content__box-btn"
                  @click="gotoPagenewtab(my_account_link + '?lang=' + lang.toUpperCase())"
                >
                  {{ getrans(brandContent.manageBooking.button) }}
                </button>
              </div>
            </div>
          </div>

          <template
            v-if="setbrandid === 'YHM' || setbrandid === 'SV1'"
          ></template>
          <template v-else>
            <div
              class="page-content__box--box-style page-content__box--box-style nqy-custom-box"
            >
              <div class="page-content__box-numbered">
                <div class="page-content__box-number">3</div>
                <div class="page-content__box-number-text">
                  <h3 class="page-content__box-title">
                    {{ getrans(brandContent.makeAnotherBooking.title) }}
                  </h3>
                  <p>{{ getrans(brandContent.makeAnotherBooking.text) }}</p>
                  <button
                    class="page-content__box-btn"
                    @click="gotoPage('/index.html')"
                  >
                    {{ getrans(brandContent.makeAnotherBooking.button) }}
                  </button>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

    <Footerpit
      v-if="setbrandid === 'PIT'"
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footerpit>
    <Footer
      v-else
      :footer_links="footer_links"
      :footer_columns="footer_columns"
      :lang="lang.toUpperCase()"
      :translations="translations"
      :brandSlug="setbrandid"
    ></Footer>
    <!-- <LoginModel /> -->
    <Cookies :brandSlug="setbrandid" :translations="translations" />
    <CookiesOld :brandSlug="setbrandid" v-if="setbrandid === 'RDU'" />
  </div>
</template>

<script>
import apiProxy from '@/services/apiProxy';

import HeaderConfim from "../../components/Header.vue";
import Footer from "../../components/Footer.vue";
import Footerpit from "../../components/FooterPIT.vue";
import ConfirmationBanner from "../../components/ConfirmationBanner.vue";
import BasketItem from "../../components/BasketItem_confirmation.vue";

import Cookies from "../../components/Cookies.vue";
import CookiesOld from "../../components/Cookies_old.vue";
import Webloyalty from "../../components/Webloyalty.vue";

import { getBrandConfig } from "../../brand/brand.config.js";
import { loadTranslations as loadTranslationsModule } from '@/modules/loadTranslations';
import confirmationContent from "@/brand/brand.confirmation_content";

//import Swal from "sweetalert2";

import { reactive } from "vue";
const crypto = require("crypto");
import md5 from "js-md5";

// Removed unused localforage and store variables

import useVuelidate from "@vuelidate/core";
const { EncryptStorage } = require("encrypt-storage");
const encryptStorage = new EncryptStorage(process.env.VUE_APP_CHL, {
  storageType: "sessionStorage",
});
import {
  required,
  email,
  numeric,
  minLength,
  maxLength,
  alpha,
} from "@vuelidate/validators";

import { set_style_vars } from "@/modules/set_style_vars";

export default {
  name: "App",
  components: {
    HeaderConfim,
    Footer,
    Footerpit,
    ConfirmationBanner,
    BasketItem,
    Cookies,
    CookiesOld,
    Webloyalty,
    // ResultsList,
    // ResultsGrid,
    // SearchWidget,
  },
  data() {
    return {
      styles_loaded: false,
      lang: "en",
      createaccount: "N",
      translations: "",
      v$: useVuelidate(),
      email: "",
      cartloaded: false,
      cartmessage: false,
      email_confirm: "",
      title: "",
      firstname: "",
      surname: "",
      phonecode: "",
      mobilenumber: "",
      country: "",
      showaddressfields: false,
      address: "",
      address_line_2: "",
      town: "",
      state: "",
      postcode: "",
      billingaddress_api: [],
      vehicle_vrn: "",
      info_block_vrn: false,
      outboundFlight: "",
      inboundFlight: "",
      info_block_flight_number: false,
      term_condition: false,
      email_consent: false,
      demo: "",
      date1_date: "",
      date1_time: "",
      date2_date: "",
      date2_time: "",
      searchres: [],
      carparkdetails: [],
      dataloaded: false,
      dataloaded_carparkdetails: false,
      widgetloaded: false,
      css_data: undefined,
      results_headline: "Official airport parking",
      results_subheadline: "11 Dec 2021 at 9:00 am - 11 Dec 2021 at 9:00 am",
      brand_data: undefined,
      brand_data_key: 0,
      brand_product_styles: reactive({}),
      brand_product_settings: {},
      brand_products: {},
      hero_desktop_background: "",
      hero_mobile_background: "",
      logo_image: "",
      hero_font_size_h1: "1.5rem",
      hero_font_size_h1_mobile: "1.3rem",
      hero_font_size_p: "1.3rem",
      hero_font_size_p_mobile: "1rem",
      hero_text_align: "center",
      hero_text_align_mobile: undefined,
      use_local_data: false,
      header_menu: [],
      footer_links: [],
      logo_link: { mtype: "Internal", url: "/" },
      home_link: undefined,
      panels_background_color: "#d6d6d6",
      panels_group: undefined,
      panel_columns: 1,
      footer_columns: "1 Columns",
      show_basket: false,
      result_selected_style: "list",
      result_selected_order: "closest",
      orderreference: "",
      final_amount_paid: 0,
      final_amount_paid_tot: 0,
      is_guest: "",
      uuid_guest: "",
      guesttomember: "",
      is_logged_in_user: false,
      setbrandid: "",
      currency: "",
      lounge_cartitem: "",
      fasttrack_cartitem: "",
      coach_cartitem: "",
      lounge_total_value: undefined,
      ftt_total_value: undefined,
      cpk_total_value: undefined,
      coach_total_value: undefined,
      cartitem: "",
      voucher: "",
      email_md5: "",

      privacy_policy_link: "",
      faqs_link: "",
      my_account_link: "",
      terms_and_conditions_link: "",
      showcart: false,
      qr_data_names: [],
      qr_product_name: "",
      qr_date: "",
      qr_time: "",
    };
  },
  validations() {
    return {
      emailid: { required, email },
      // title: { required },
      firstname: { required, alpha, minLength: minLength(2) },
      surname: { required, alpha, minLength: minLength(2) },
      Email: { required, email },
      EmailConfirm: { required, email },
      phonecode: { required },
      state: { required },
      mobilenumber: {
        required,
        numeric,
        minLength: minLength(7),
        maxLength: maxLength(15),
      },
      address: { required },
      postcode: { required },
      town: { required },
      country: { required },
      vehicle_vrn: { required },
      term_condition: {
        required(val) {
          return val;
        },
      },
    };
  },
  computed: {
    brandContent() {
      return confirmationContent[this.setbrandid] || confirmationContent.DEFAULT;
    },
    new_style_variables() {
      return set_style_vars(this.brand_product_styles, "yourdetails");
    },
    set_style_variables: function () {
      return {
        "--hero-background-mobile": `url(${this.hero_desktop_background})`,
        "--hero-background-desktop": this.hero_mobile_background
          ? `url(${this.hero_mobile_background})`
          : `url(${this.hero_desktop_background})`,
        "--hero-font-size-h1": this.hero_font_size_h1,
        "--hero-font-size-h1-mobile": this.hero_font_size_h1_mobile,
        "--hero-font-size-p": this.hero_font_size_p,
        "--hero-font-size-p-mobile": this.hero_font_size_p_mobile,
        "--hero-text-align": this.hero_text_align,
        "--hero-text-align-mobile":
          this.hero_text_align_mobile || this.hero_text_align,
        "--panel-background-color": this.panels_background_color,
      };
    },
  },
  methods: {
    currency_formatter(money) {
      if (!money) return;
      const brandConfig = getBrandConfig(this.setbrandid);
      if (brandConfig.features?.currencyAfterValue) {
        money = money.toString().replace(".", ",");
        return money + " " + this.currency;
      }
      return this.currency + " " + money;
    },
    async createaccountaction() {
      const chdata = this.setbrandid + encryptStorage.getItem("order_ref") + encryptStorage.getItem("final_uuid") + encryptStorage.getItem("tag_email");
      const hash = crypto.createHash("sha512");
      const transaction_token = hash.update(chdata, "utf-8").digest("hex");
      
      const pspdata = {
        uuid: encryptStorage.getItem("final_uuid"),
        brand_id: this.setbrandid,
        order_ref: encryptStorage.getItem("final_orderreference"),
        email: encryptStorage.getItem("tag_email"),
        transaction_token: transaction_token,
      };

      const response = await apiProxy.call("guest_to_member", pspdata);
      const accountCreated =
        response &&
        (response.success === "Y" ||
          response.success === true ||
          response.user_exists === "Y" ||
          response.user_exists === true);
      if (accountCreated) {
        this.demo = response;
        encryptStorage.setItem("is_guest", "N");
        encryptStorage.setItem("guesttomember", "Y");
        this.createaccount = "Y";
      } else {
        this.loading_proceed = false;
      }
    },
    getrans(key) {
      var s = md5(key);
      var ss = this.setbrandid + "-" + this.lang.toUpperCase() + "-" + s;
      return this.translations[ss] || key;
    },
    getSessionData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setSessionData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    async loadTranslations() {
      const translations = await loadTranslationsModule(this.setbrandid);
      this.translations = translations;
      this.lang = sessionStorage.getItem('language') || this.lang || 'en';
    },

    formatDatedmy(date) {
      date = date.split("/");
      date = date[2] + "/" + date[1] + "/" + date[0];
      return date;
    },
    populateaddress(event) {
      let optionText = event.target.value;
      let postcode_search_ar = optionText.split("~");
      this.address = postcode_search_ar[0];
      this.address_line_2 = postcode_search_ar[1];
      this.town = postcode_search_ar[2];
      this.state = postcode_search_ar[3];
      this.showaddressfields = true;
      this.billingaddress_api = "";
    },
    selectcountry() {
      let coun = this.country;
      if (coun != "GB" && coun != "") {
        this.showaddressfields = true;
      } else {
        this.showaddressfields = false;
      }
    },
    findyouraddress() {},
    upperCaseVRN(newValue) {
      this.vrn_number = newValue.toUpperCase();
    },
    lowerCaseEmail(newValue) {
      this.email = newValue.toLowerCase();
    },
    lowerCaseEmail_Confirm(newValue) {
      this.email_confirm = newValue.toLowerCase();
    },
    setListStyle(type) {
      this.result_selected_style = type;
    },
    setListOrder(type) {
      this.result_selected_order = type;
    },
    getLocalData(name) {
      return JSON.parse(sessionStorage.getItem(name));
    },
    setLocalData(name, value) {
      if (value != null) sessionStorage.setItem(name, JSON.stringify(value));
      else sessionStorage.removeItem(name);
    },
    setBrandData() {
      this.brand_data = this.getLocalData("brand_data");
      this.setStyles(this.brand_data.brand_product_styles);
      this.brand_product_settings = this.brand_data.brand_product_settings;
      this.brand_products = this.brand_data.brand_products;
      this.brand_data_key++;
      this.styles_loaded = true;

      // Set links from config if available
      const brandContent = this.brandContent || {};
      this.privacy_policy_link = brandContent.privacyPolicyLink || "";
      this.faqs_link = brandContent.faqLink || "";
      this.my_account_link = brandContent.myAccountLink || "";
      this.terms_and_conditions_link = brandContent.termsAndConditionsLink || "";
    },
    async getBrandData() {
      if (this.use_local_data && this.getLocalData("brand_data")) {
        this.setBrandData();
      } else {
        const response = await apiProxy.call("brand_details", { brandslug: this.setbrandid });
        if (response && response.code == '1') {
          this.setLocalData("brand_data", response);
          this.setMenu(response);
          this.createPanels(response);
          this.setBrandData();
          this.getorderdetails();
        }
      }
    },
    setStyles(obj) {
      /* eslint-disable */
      if (!obj) return;
      obj.forEach((item) => {
        for (const [classname, style] of Object.entries(item)) {
          this.brand_product_styles[classname] = style;
        }
      });
      // console.log(this.brand_product_styles["asset_image_1"]);
      this.logo_image = this.brand_product_styles["asset_image_1"];
      this.hero_font_size_h1 =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_h1_mobile =
        this.brand_product_styles["panel_heading_font_size"];
      this.hero_font_size_p = this.brand_product_styles["panel_text_font_size"];
      this.hero_font_size_p_mobile =
        this.brand_product_styles["panel_text_font_size"];
      /* eslint-enable */
    },
    setMenu(data) {
      if (!Array.isArray(data.brand_menu) || !data.brand_menu.length > 0)
        return;
      data.brand_menu.forEach((menu) => {
        if (menu.label.toLowerCase() === "home") {
          this.home_link = menu.url;
        }
        if (menu.label.toLowerCase() === "logo") {
          this.logo_link = menu;
        }
        menu.loggedin = true;
        menu.loggedout = true;
      });

      const top_menu = data.brand_menu.filter((menu) => menu.position === "T");
      this.createHeaderLinks(top_menu);

      const footer_menu = data.brand_menu.filter(
        (menu) => menu.position === "B"
      );
      this.createFooterLinks(footer_menu);
    },
    gotoPage(url) {
      window.location.href = url;
    },
    gotoPagenewtab(url) {

      let logKey;
      let mmb_link = encryptStorage.getItem("mmb_link");

      if (mmb_link && url.indexOf(mmb_link) > -1) {
        console.log("enw_log_key", logKey);
        logKey = encryptStorage.getItem("enw_log_key");
      }

      if (location.host == 'laxstaging.rezcomm.com' && url.indexOf('myparking.flylax.com') > -1) {
        logKey = encryptStorage.getItem("enw_log_key");
        url = 'https://laxmanagemyaccountstaging.rezcomm.com/';
      }

      // Append mmb_link as a query parameter
      if (logKey) {
        const urlObj = new URL(url, window.location.origin);
        urlObj.searchParams.set("log_key", logKey);
        url = urlObj.toString();
      }

      // Append lang if needed
      if (
        (url.indexOf("myaccountdev.") > -1 || url.indexOf("myaccount.") > -1 || url.indexOf(".rezcomm") > -1) &&
        this.lang
      ) {
        const urlObj = new URL(url);
        urlObj.searchParams.set("lang", this.lang);
        url = urlObj.toString();
      }

      window.open(url, "_blank");
    },
    createHeaderLinks(data) {
      const header_menu = [];
      if (data.length > 0) {
        data.forEach((menu) => {
          if (menu.label.toLowerCase() === "basket") {
            this.show_basket = true;
          } else if (
            menu.label.toLowerCase() !== "home" &&
            menu.label.toLowerCase() !== "logo"
          ) {
            header_menu.push(menu);
          }
        });
      }
      this.header_menu = header_menu;
    },
    createFooterLinks(data) {
      this.footer_columns = data[0].mcolumn;
      this.footer_links = data.reduce((a, r) => {
        if (!a[r.mgroup]) a[r.mgroup] = { group: r.mgroup, data: [] };
        a[r.mgroup].data.push(r);
        return a;
      }, {});
    },
    createPanels(data) {
      let panels_data = data.brand_home_panels || [];
      panels_data.sort((a, b) => (a.rownum > b.rownum ? 1 : -1));
      panels_data = panels_data.reduce((a, r) => {
        if (!a[r.rownum]) a[r.rownum] = { row: r.rownum, columns: [] };
        a[r.rownum].columns.push(r);
        return a;
      }, {});
      this.panels_group = panels_data;
    },
    correctdate(d) {
      d = d.replace("st", "");
      d = d.replace("nd", "");
      d = d.replace("rd", "");
      d = d.replace("th", "");
      return d;
    },
    formatDateymd(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();
      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;
      return [year, month, day].join("/");
    },
    async sendemailfailure() {
      let data = {
        cartitem: this.cartitem,
        brand_id: this.setbrandid,
        booking_ref_id: this.getLocalData("order_ref"),
        email: this.getLocalData("tag_email"),
      };
      const response = await apiProxy.call("parking_fail_to_book", data);
      if (response && response.user_exists) {
        //sessionStorage.clear();
        console.log(response);
      } else {
        //sessionStorage.clear();
        console.log(response);
      }
    },
    getPurchaseSentRegistry() {
      const key = "v6_purchase_sent";
      const ttl = 30 * 24 * 60 * 60 * 1000;
      const now = Date.now();
      let sent = {};

      try {
        sent = JSON.parse(localStorage.getItem(key) || "{}");
      } catch (error) {
        console.warn("Unable to read purchase tracking registry", error);
        sent = {};
      }

      Object.keys(sent).forEach((transactionId) => {
        if (!sent[transactionId] || now - sent[transactionId] > ttl) {
          delete sent[transactionId];
        }
      });

      return { key, sent, now };
    },
    hasPurchaseAlreadyBeenSent(transactionId) {
      const { sent } = this.getPurchaseSentRegistry();
      return Boolean(sent[transactionId]);
    },
    markPurchaseSent(transactionId) {
      const { key, sent, now } = this.getPurchaseSentRegistry();
      sent[transactionId] = now;

      try {
        localStorage.setItem(key, JSON.stringify(sent));
      } catch (error) {
        console.warn("Unable to store purchase tracking registry", error);
      }
    },
    pruneEmptyDataLayerFields(value) {
      if (Array.isArray(value)) {
        return value
          .map((item) => this.pruneEmptyDataLayerFields(item))
          .filter((item) => item !== undefined);
      }

      if (value && typeof value === "object") {
        return Object.entries(value).reduce((result, [key, item]) => {
          const pruned = this.pruneEmptyDataLayerFields(item);
          if (pruned !== undefined) {
            result[key] = pruned;
          }
          return result;
        }, {});
      }

      if (value === undefined || value === null || value === "") {
        return undefined;
      }

      return value;
    },
    toDataLayerAmount(value) {
      const amount = Number.parseFloat(value);
      return Number.isFinite(amount) ? amount : 0;
    },
    normalizePurchaseItemsForValue(items, purchaseValue, coupon) {
      if (!Array.isArray(items) || !items.length || !Number.isFinite(purchaseValue)) {
        return items;
      }

      const currentValue = items.reduce((sum, item) => {
        const quantity = Number(item.quantity || 1) || 1;
        return sum + this.toDataLayerAmount(item.price) * quantity;
      }, 0);

      if (!currentValue || Math.abs(currentValue - purchaseValue) <= 0.01) {
        return items.map((item) => ({ ...item }));
      }

      let remainingValue = Number(purchaseValue.toFixed(2));
      return items.map((item, index) => {
        const quantity = Number(item.quantity || 1) || 1;
        const originalUnitPrice = this.toDataLayerAmount(item.price);
        const adjustedItem = { ...item };
        const unitPrice =
          index === items.length - 1
            ? remainingValue / quantity
            : originalUnitPrice * (purchaseValue / currentValue);
        const roundedUnitPrice = Number(unitPrice.toFixed(2));

        remainingValue = Number(
          (remainingValue - roundedUnitPrice * quantity).toFixed(2)
        );
        adjustedItem.price = roundedUnitPrice;

        if (originalUnitPrice > roundedUnitPrice) {
          adjustedItem.discount = Number(
            (originalUnitPrice - roundedUnitPrice).toFixed(2)
          );
        }

        if (coupon) {
          adjustedItem.coupon = coupon;
        }

        return adjustedItem;
      });
    },
    async getbranded() {
      const response = await apiProxy.call("brand_slug");
      if (response && response.code == "1") {
        this.setbrandid = response.slug;
        this.currency = response.currency;
        await this.utmdata(response.slug);
        if (["HER", "NOC", "SZG", "FM1", "FMM", "PB1", "BRE", "NUE"].includes(response.slug)) {
          this.currency = "€";
        }
        await this.loadTranslations();
        await this.getBrandData();
        this.enw_log();
        this.sendToDataLayer();
        this.set_Webloyalty();
      }
    },
    sendToDataLayer() {
      if (this.setbrandid === "NWI") {
        console.log("sendToDataLayer", this.fasttrack_cartitem);

        let items = [];
        let parking_obj = {};
        let lounge_obj = {};

        if (this.cartitem !== undefined) {
          console.log("sendToDataLayer cpk", this.cartitem);
          parking_obj.item_id = this.cartitem.product_id;
          parking_obj.item_name = this.cartitem.product_name;
          parking_obj.item_category = "Parking";
          parking_obj.price = this.cartitem.price;
          parking_obj.quantity = 1;
          items.push(parking_obj);
        }

        if (this.lounge_cartitem !== undefined) {
          console.log("sendToDataLayer lng", this.lounge_cartitem);
          lounge_obj.item_id = this.lounge_cartitem.lounge_id;
          lounge_obj.item_name = this.lounge_cartitem.product_name;
          lounge_obj.item_category = "Lounge";
          lounge_obj.price = this.lounge_cartitem.loungesubtotal;
          lounge_obj.quantity =
            Number(this.lounge_cartitem.ADL) +
            Number(this.lounge_cartitem.CHD) +
            Number(this.lounge_cartitem.INF);
          items.push(lounge_obj);
        }

        console.log("items", items);
        // todo add tax promocode & ftt?

        /* eslint-disable */
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({
          event: "purchase",
          ecommerce: {
            currency: "GBP",
            transaction_id: this.orderreference,
            value: this.final_amount_paid_tot, //total purchase amount including tax
            tax: "", //value of tax on purchase
            coupon: "", //if a promo code has been used for the purchase, include it here. If not, leave blank
            items: items,
          },
        });

        console.log("datalayer", dataLayer);
        /* eslint-enable */
      }
      if (this.setbrandid === "AIR" || this.setbrandid == "BHX") {
        const transactionId = String(this.orderreference || "").trim();
        if (!transactionId) {
          console.error("Purchase dataLayer not pushed: missing transaction_id", {
            brand_id: this.setbrandid,
            orderreference: this.orderreference,
          });
          return;
        }

        if (this.hasPurchaseAlreadyBeenSent(transactionId)) {
          console.log("Purchase dataLayer already sent, skipping duplicate", {
            brand_id: this.setbrandid,
            transaction_id: transactionId,
          });
          return;
        }

        const isTbScriptLoaded = typeof Tinybird !== "undefined";
        let userdata = encryptStorage.getItem("newuser");
        let returning_customer = "No";
        if (userdata !== undefined) {
          if (userdata == "0") {
            returning_customer = "Yes";
          }
        }
        console.log("isTbScriptLoaded", isTbScriptLoaded);

        if (isTbScriptLoaded) {
          window.Tinybird.trackEvent("conversion", {
            brand_id: this.setbrandid,
            orderreference: "AIR-CPK-" + this.orderreference,
            returning_customer: returning_customer,
            ordertotal: this.final_amount_paid_tot,
          });
        } else {
          let scriptEle = document.createElement("script");
          scriptEle.setAttribute(
            "src",
            "https://unpkg.com/@tinybirdco/flock.js"
          );
          scriptEle.setAttribute(
            "data-token",
            "p.eyJ1IjogIjExNjc3NDUwLWJkYjAtNGEyNi05NTZlLTlmNGE0OWNlNjAxZiIsICJpZCI6ICIyNjk2YTM0Zi0yNjJlLTRmOTgtYWM2Zi1hNTAwMTVmMTQ5ODQifQ.qAkna78f0qF7lAVtIsZ3k-DrFZh6F-UtkrdBldgLzd0"
          );
          document.body.appendChild(scriptEle);
          scriptEle.addEventListener("load", () => {
            console.log("tn script loaded");
            window.Tinybird.trackEvent("conversion", {
              brand_id: this.setbrandid,
              orderreference: this.orderreference,
              returning_customer: returning_customer,
              ordertotal: this.final_amount_paid_tot,
            });
          });

          scriptEle.addEventListener("error", (ev) => {
            console.log("Error on loading tn script", ev);
          });
        }

        let datalayerparams = encryptStorage.getItem("datalayerparams");
        if (typeof datalayerparams === "string") {
          try {
            datalayerparams = JSON.parse(datalayerparams);
          } catch (e) {
            datalayerparams = {};
          }
        }
        if (
          typeof datalayerparams !== "object" ||
          datalayerparams === null
        ) {
          datalayerparams = {};
        }

        const keys = ["cpk", "ftt", "lng"];
        let items = [];
        let currency = "GBP";

        keys.forEach((key) => {
          const source = datalayerparams[key];
          const entries = Array.isArray(source) ? source : [source];

          entries.forEach((entry) => {
            const ecommerce =
              entry &&
              entry.ecommerce &&
              typeof entry.ecommerce === "object"
                ? entry.ecommerce
                : null;

            if (!ecommerce) {
              return;
            }

            if (typeof ecommerce.currency === "string" && ecommerce.currency) {
              currency = ecommerce.currency;
            }
            if (Array.isArray(ecommerce.items)) {
              items = items.concat(
                ecommerce.items.filter((item) => item && typeof item === "object")
              );
            }
          });
        });

        if (!items.length) {
          const fallbackEcommerce =
            datalayerparams.ecommerce &&
            typeof datalayerparams.ecommerce === "object"
              ? datalayerparams.ecommerce
              : null;
          if (fallbackEcommerce) {
            if (
              typeof fallbackEcommerce.currency === "string" &&
              fallbackEcommerce.currency
            ) {
              currency = fallbackEcommerce.currency;
            }
            if (Array.isArray(fallbackEcommerce.items)) {
              items = fallbackEcommerce.items.filter(
                (item) => item && typeof item === "object"
              );
            }
          }
        }

        const fallbackValue = items.reduce(
          (sum, item) =>
            sum + Number.parseFloat(item.price || 0) * Number(item.quantity || 1),
          0
        );
        let purchaseValue = Number.parseFloat(this.final_amount_paid_tot);
        if (!Number.isFinite(purchaseValue)) {
          purchaseValue = fallbackValue;
        }
        const couponRaw = encryptStorage.getItem("discount_coupon_applied");
        const couponFromStorage =
          typeof couponRaw === "string"
            ? couponRaw.trim()
            : String(couponRaw || "").trim();
        const couponFromState =
          typeof this.voucher === "string"
            ? this.voucher.trim()
            : String(this.voucher || "").trim();
        const coupon = couponFromStorage || couponFromState;

        const purchaseTrackingPayload =
          encryptStorage.getItem("purchase_tracking_payload") || {};
        const userData =
          purchaseTrackingPayload &&
          typeof purchaseTrackingPayload === "object" &&
          purchaseTrackingPayload.user_data &&
          typeof purchaseTrackingPayload.user_data === "object"
            ? purchaseTrackingPayload.user_data
            : {
                email: "",
                phone_number: "",
                address: {
                  first_name: "",
                  last_name: "",
                  street: "",
                  city: "",
                  region: "",
                  country: "",
                  postal_code: "",
                },
              };
        const attributionData =
          purchaseTrackingPayload &&
          typeof purchaseTrackingPayload === "object" &&
          purchaseTrackingPayload.attribution_data &&
          typeof purchaseTrackingPayload.attribution_data === "object"
            ? purchaseTrackingPayload.attribution_data
            : {
                gclid: "",
                ppid: "",
                mobile_advertiser_id: "",
              };
        const prunedUserData = this.pruneEmptyDataLayerFields(userData);
        const prunedAttributionData =
          this.pruneEmptyDataLayerFields(attributionData);
        const purchaseItems = this.normalizePurchaseItemsForValue(
          items,
          purchaseValue,
          coupon
        );
        const purchasePayload = {
          event: "purchase",
          ecommerce: {
            transaction_id: transactionId,
            value: Number(purchaseValue.toFixed(2)),
            currency: currency,
            items: purchaseItems,
            ...(coupon ? { coupon } : {}),
          },
        };

        if (prunedUserData && Object.keys(prunedUserData).length) {
          purchasePayload.user_data = prunedUserData;
        }

        if (
          prunedAttributionData &&
          Object.keys(prunedAttributionData).length
        ) {
          purchasePayload.attribution_data = prunedAttributionData;
        }

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(purchasePayload);
        this.markPurchaseSent(transactionId);

        if (this.setbrandid === 'BHX') {
          // Give 'em time to load in...
          setTimeout(() => {
            if (window.ADT && window.ADT.Tag) {
              window.ADT.Tag.t = 3;
              window.ADT.Tag.c = "GBP";
              window.ADT.Tag.tp = 2039753313;
              window.ADT.Tag.am = Number(purchaseValue.toFixed(2));
              window.ADT.Tag.ti = transactionId;
              window.ADT.Tag.xd = this.email_md5 || '';
              window.ADT.Tag.cpn = this.voucher || '';
              window.ADT.Tag.doEvent();
            }
          }, 2000);
        }
      }
    },

    gensessionid() {
      if (encryptStorage.getItem("search_analytics_id") === undefined) {
        let search_analytics_id = crypto.randomBytes(16).toString("base64");
        encryptStorage.setItem("search_analytics_id", search_analytics_id);
        return search_analytics_id;
      } else {
        return encryptStorage.getItem("search_analytics_id");
      }
    },
    async utmdata(brandslug) {
      let sessid = "";
      let analytics = "0";
      if (!this.$cookie.isCookieAvailable("session-id")) {
        this.gensessionid();
        sessid = encryptStorage.getItem("search_analytics_id");
      } else {
        sessid = this.$cookie.getCookie("session-id");
        analytics = "1";
      }
      if (this.$cookie.isCookieAvailable("utm_partner")) {
        let trackevents = {
          page: window.location.href,
          analytics: analytics,
          orderpaid: "1",
          orderreference: encryptStorage.getItem("orefwithoutprefix"),
        };
        let tdata = {
          utm_campaign: this.$cookie.getCookie("utm_campaign"),
          utm_content: this.$cookie.getCookie("utm_content"),
          utm_medium: this.$cookie.getCookie("utm_medium"),
          utm_partner: this.$cookie.getCookie("utm_partner"),
          utm_source: this.$cookie.getCookie("utm_source"),
          utm_sub_partner: this.$cookie.getCookie("utm_sub_partner"),
          utm_term: this.$cookie.getCookie("utm_term"),
          session_id: sessid,
          trackevents: trackevents,
          brandslug: brandslug,
        };

        const response = await apiProxy.call('utm_campaign', tdata);
        if (response && response.data) {
          console.log("utmdata", response.data);
        }
      }
    },
    async getorderdetails() {
      console.log(
        "fasttrack_cart_coach",
        encryptStorage.getItem("fasttrack_cart_coach")
      );

      if (
        typeof encryptStorage.getItem("fasttrack_cart_coach") !== "undefined"
      ) {
        let datasearch = {
          uuid: this.getLocalData("uuid"),
          slug: this.setbrandid,
          orderreference: `HER-FTT-` + this.orderreference,
        };
        const response = await apiProxy.call("customer_bookings_frankfurt", datasearch);
        if (response && response.result) {
          let data = response;
            //let refunds = [];
            //refunds = data.refunds;
            //this.cpms_reference = data.cpms_reference;
            this.orderdata = data.result[0];
            this.emailentered_order = this.orderdata.email;

            let cartdetails = "";

            try {
              cartdetails = JSON.parse(data.result[0].cart);
            } catch (err) {
              cartdetails = JSON.parse(JSON.stringify(data.result[0].cart));
            }
            if (cartdetails.date_selected === undefined) {
              cartdetails = JSON.parse(cartdetails);
            }
            console.log("cartdetails", cartdetails.date_selected);

            this.ekashu_transaction_id = "";
            console.log("this.orderdata", this.orderdata);

            console.log("response-------------------", response);

            this.qr_data_names = JSON.parse(response.data.refunds[0].names);
            let names = [];
            for (let b = 0; b < this.qr_data_names.length; b++) {
              let it = this.qr_data_names[b];
              let a = it.indexOf("Adult");
              let c = it.indexOf("Child");
              let i = it.indexOf("Infant");
              let j = b + 1;
              if (a >= 0) {
                names.push("Adult " + j);
              }
              if (c >= 0) {
                names.push("Child " + j);
              }
              if (i >= 0) {
                names.push("Infant " + j);
              }
            }
            this.qr_data_names = names;
            this.qr_data_qrcodes = response.data.refunds[0].qrcodes;
            console.log("this.qr_data_names", this.qr_data_names);

            this.qr_image_src = response.data.refunds[0].qrurl;
            this.qrurlorig_image_src = response.data.refunds[0].qrurlorig;

            this.qr_date = cartdetails.date_selected
              .split("/")
              .reverse()
              .join("/");
            this.qr_time = cartdetails.time_selected;
            this.qr_product_name = cartdetails.product_name;

            this.ordercomplete = true;
        }
      }
    },

    
    async enw_log() {
      // Generate a transaction token using a secure hash
      let chdata = this.setbrandid.toLowerCase() + this.getLocalData("uuid");
      let hash = crypto.createHash("sha512");
      let transaction_token = hash.update(chdata, "utf-8").digest("hex");

      // Create request data with timestamp for freshness
      let datasearch = {
        uuid: this.getLocalData("uuid"),
        brand_id: this.setbrandid.toLowerCase(),
        orderreference: this.orderreference,
        transaction_token: transaction_token,
        timestamp: Date.now(), // Add timestamp for request freshness
      };



      // Make API request with security headers
      const response = await apiProxy.call("live_alog_enw", datasearch);
      if (response && response.user_exists === "Y") {
        // Store token securely with expiration
        if (response.data) {
          encryptStorage.setItem("enw_log_key", response.data);
          encryptStorage.setItem("mmb_link", response.mmb_link);
          this.logKey = encryptStorage.getItem("enw_log_key");
          this.updateHeader += 1;
        }
      } else {
        console.error("Authentication error");
        // Don't log detailed error information
      }
    },

    set_Webloyalty() {
      if (
        this.setbrandid === "BHX"
      ) {
        // Webloyalty
        /* eslint-disable */ 
        (function(i){if(i&&i.a.length>0){var c=document;var d=function d(e){for(var r="",a=0;a<e.length;a++){r+=""+e.charCodeAt(a).toString(16)}return r};var v=function v(e){for(var r=e.toString(),a="",n=0;n<r.length&&"00"!==r.substr(n,2);n+=2){a+=String.fromCharCode(parseInt(r.substr(n,2),16))}return a};var u=function u(){for(var e=0;e<i.a.length;e++){var r=Math.floor(Date.now()/1e3);var a="";var n="";if(i.a[e].ckw!==undefined){n=i.a[e].ckw}if(n.slice(-1)!==";"&&n.slice(-1)!==""){n+=";"}if(i.a[e].k!==undefined){a="kw="+i.a[e].k+";"}var t=a+n;var f=v(i.u)+"/"+r+"/"+s+"/"+l+"/"+window.atob(i.a[e].a)+"/"+i.b+"/"+i.c+"/"+d(t);var o=c.createElement("script");o.async=true;o.src=f;c.getElementById("w"+v(i.a[e].h)).appendChild(o)}};var f=function f(){var e=[];for(var r=0;r<i.a.length;r++){e.push(i.a[r].r)}if(e.indexOf(true)>-1&&i.hasOwnProperty("b")){i.r=true}e=[];if(i.r){u()}};var a=function a(){function e(){if(c.getElementById("Adwl")!==null){i.b=0}else{i.b=1}}function r(e,r){var a=c.getElementsByTagName("body")[0];var n=c.createElement("script");n.src=v(e);if(typeof r!=="undefined"){n.onload=r;n.onerror=r}a.appendChild(n);o()}if(typeof e==="function"){r("68747470733a2f2f6433646835633772777a6c69776d2e636c6f756466726f6e742e6e65742f6164766572746973656d656e742e6a733f6466703d31",e)}};var o=function o(){var e="68747470733a2f2f643332313036726c6864636f676f2e636c6f756466726f6e742e6e65742f";var r="";var a=Math.floor(Date.now()/1e3);for(var n=0;n<i.a.length;n++){r+=i.a[n].h;if(n<i.a.length-1){r+="/"}}var t=c.createElement("script");t.async=true;t.src=v(e)+a+"/"+s+"/"+l+"/"+r;t.onload=f;c.body.appendChild(t)};var l="3";var s="33";a();}})(function(){var e="dDropI";var r=window[e[4]+e[2]+e[3]+e[0]+e[5]+e[1]];return typeof r!==undefined?r:false}());
        /* eslint-enable */
      }
    },



  },
  created() {},
  mounted() {
    // Remove the loader once Vue is initialized
    const loader = document.getElementById("loader");
    if (loader) {
      loader.parentNode.removeChild(loader);
    }
    // Capture voucher before async brand/bootstrap flow triggers purchase event.
    this.voucher = encryptStorage.getItem("discount_coupon_applied");
    //this.setbrandid = "BOS";
    //this.currency = "$";
    this.getbranded();
    // console.log("window.location.hostname", window.location.hostname);
    // if (this.setbrandid == "") {
    //   this.setbrandid = "BOS";
    //   this.currency = "$";
    //   if (window.location.hostname == "herv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "HER";
    //     this.currency = "€";
    //   }
    //   if (window.location.hostname == "nwiv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "NWI";
    //     this.currency = "£";
    //   }
    //   if (window.location.hostname == "rduv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "RDU";
    //     this.currency = "$";
    //   }
    //   if (window.location.hostname == "bosv6devcombined.rezcommdev.com") {
    //     this.setbrandid = "BOS";
    //     this.currency = "$";
    //   }
    // }
    this.cartitem = encryptStorage.getItem("cart");
    this.fasttrack_cartitem = encryptStorage.getItem("fasttrack_cart");
    //console.log("fasttrack_cartitem", this.fasttrack_cartitem);
    this.lounge_cartitem = encryptStorage.getItem("lounge_cart");
    console.log("cartitem", this.cartitem);
    console.log("lounge_cartitem", this.lounge_cartitem);
    console.log("coach_cartitem", this.coach_cartitem);
    this.coach_cartitem = encryptStorage.getItem("coach_cart");
    encryptStorage.removeItem("coach_selected_model");
    this.orderreference = encryptStorage.getItem("orefwithoutprefix");
    this.is_guest = encryptStorage.getItem("is_guest");
    this.guesttomember = encryptStorage.getItem("guesttomember");
    const sessionUserData = encryptStorage.getItem("session_userdata");
    this.is_logged_in_user = Boolean(
      sessionUserData &&
        ((typeof sessionUserData === "object" &&
          Object.keys(sessionUserData).length > 0) ||
          (typeof sessionUserData === "string" && sessionUserData.trim()))
    );
    this.final_amount_paid_tot = encryptStorage.getItem("final_amount_paid");
    this.lounge_total_value = encryptStorage.getItem("finaltotalvalue_lng");
    this.ftt_total_value = encryptStorage.getItem("finaltotalvalue_ftt");
    this.cpk_total_value = encryptStorage.getItem("finaltotalvalue_cpk");
    this.coach_total_value = encryptStorage.getItem("finaltotalvalue_chp");
    this.email_md5 = encryptStorage.getItem("email_md5");
    console.log("CONFIRM totals", {
      lounge_total_value: this.lounge_total_value,
      ftt_total_value: this.ftt_total_value,
      cpk_total_value: this.cpk_total_value,
      coach_total_value: this.coach_total_value,
      final_amount_paid_tot: this.final_amount_paid_tot,
    });
    console.log("CONFIRM cpk sources", {
      tot_price: this.cartitem?.price,
      ordertotal: this.cartitem?.ordertotal,
      cartitem: this.cartitem,
      finaltotalvalue_cpk: encryptStorage.getItem("finaltotalvalue_cpk"),
      dis_cpk: encryptStorage.getItem("dis_cpk"),
      discount_amount: encryptStorage.getItem("discount_amount"),
      discount_amount_applied: encryptStorage.getItem("discount_amount_applied"),
      discount_coupon_applied: encryptStorage.getItem("discount_coupon_applied"),
    });
    console.log("final_amount_paid", this.final_amount_paid);
    this.cartloaded = true;
    if (typeof encryptStorage.getItem("discount_amount") !== "undefined") {
      console.log("aaaaaa");
      this.final_amount_paid = encryptStorage.getItem("final_amount_paid");
    } else {
      console.log("bbbbb");
      if (this.cartitem && this.cartitem.price) {
        this.final_amount_paid = this.cartitem.price;
      }
    }
    this.showcart = true;
    if (window.location.hostname !== "localhost") {
      console.log("CONFIRM clearing encryptStorage/sessionStorage");
      sessionStorage.removeItem("cart");
      sessionStorage.removeItem("fasttrack_cart");
      sessionStorage.removeItem("lounge_cart");
      sessionStorage.removeItem("coach_cart");
      sessionStorage.removeItem("orefwithoutprefix");
      sessionStorage.removeItem("orefwithoutprefix_brand");
      encryptStorage.removeItem("cart");
      encryptStorage.removeItem("oldcart");
      encryptStorage.removeItem("tag_totcost");
      encryptStorage.removeItem("fasttrack_cart");
      encryptStorage.removeItem("final_orderreference");
      encryptStorage.removeItem("lounge_cart");
      encryptStorage.removeItem("coach_cart");
      encryptStorage.removeItem("orefwithoutprefix");
      encryptStorage.removeItem("orefwithoutprefix_brand");
      encryptStorage.removeItem("order_ref");
      encryptStorage.removeItem("dis_cpk");
      encryptStorage.removeItem("dis_ftt");
      encryptStorage.removeItem("dis_lng");
      encryptStorage.removeItem("discount_amount");
      encryptStorage.removeItem("discount_amount_applied");
      encryptStorage.removeItem("discount_coupon_applied");
      encryptStorage.removeItem("final_amount_paid");
      encryptStorage.removeItem("orderplaced");
      encryptStorage.removeItem("crosssell_fttshown");
      encryptStorage.removeItem("finaltotalvalue_lng");
      encryptStorage.removeItem("finaltotalvalue_ftt");
      encryptStorage.removeItem("finaltotalvalue_cpk");
      encryptStorage.removeItem("crosssell_lngshown");
      encryptStorage.removeItem("email_md5");
    }
  },
};
</script>

<style lang="scss">
@import "@/assets/sass/normalise.scss";
@import "@/assets/sass/bodyStyle.scss";
@import "@/assets/sass/formStyles.scss";
@import "@/assets/sass/override_brand.scss";
.tab-basket {
  display: none !important;
}
</style>

<style scoped lang="scss">
@import "@/assets/sass/variables.scss";

.confirmation-banner-container {
  height: 171px;
  background: var(
    --header_banner_background,
    transparent linear-gradient(#0871b9 0%, #034a94 100%) 0% 0% no-repeat
      padding-box
  );
  display: flex;
  align-items: center;

  @media screen and (max-width: 1260px) {
    padding: 0 1rem;
  }
}

.page-content {
  // outline: 1px solid red;
  max-width: 1300px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  // margin-top: -3.5rem;
  margin-top: 1rem;
  gap: 2rem;

  @media screen and (min-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }
  &--fullwidth {
    text-align: center;
    @media screen and (min-width: 960px) {
      grid-template-columns: 1fr;
      text-align: left;
    }
  }

  padding: 1rem;

  &__box {
    // outline: 1px solid green;

    &--box-style {
      background: #ffffff;
      box-shadow: 0px 3px 6px #00000029;
      border: 1px solid #dfdfdf;
      padding: 1em 1.375rem;
      margin-bottom: 2rem;
      @media screen and (min-width: 960px) {
        padding: 1.5em 1.875rem;
      }
    }

    &--box-center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
    }
  }

  &__box-details {
    padding: 1em 1rem 1rem 1.375rem;
    padding-right: calc(1rem - 20px);
  }

  &__box-ref {
    display: flex;
    justify-content: space-between;
    font-size: 1.25rem;
    border-top: 1px solid #55555555;
    border-bottom: 1px solid #55555555;
    padding: 1rem 0;
  }

  &__box-proceed {
    margin-bottom: 1rem;
    button {
      width: 100%;
      padding: 1em;
      background: #034a94;
      color: #fff;
      border: 0px;
      border-radius: 0.25rem;
    }
  }

  &__box-numbered {
    display: flex;
    justify-content: flex-start;
  }

  &__box-number {
    width: 3.5rem;
    height: 3.5rem;
    min-width: 3.5rem;
    min-height: 3.5rem;
    // display: flex;
    display: none;
    justify-content: center;
    align-items: center;
    border-radius: 3rem;
    margin-right: 1rem;
    background: var(--details_numbers_confirmation_background, #2474a6);
    color: var(--details_numbers_confirmation_font_color, #fff);
    border: var(--details_numbers_confirmation_border, none);
    font-family: var(--details_numbers_confirmation_font_family, inherit);
    font-size: var(--details_numbers_confirmation_font_size, 2rem);
    font-weight: var(--details_numbers_confirmation_font_weight, bold);
  }

  &__box-number-text {
    width: 100%;
  }

  &__box-btn {
    width: 100%;
    padding: 1em;
    background: var(--details_buttons_confirmation_background, #034a94);
    color: var(--details_buttons_confirmation_font_color, #fff);
    border: var(--details_buttons_confirmation_border, none);
    border-radius: var(--details_buttons_confirmation_border_radius, 0.25rem);
    font-family: var(--details_buttons_confirmation_font_family, inherit);
    font-size: var(--details_buttons_confirmation_font_size, 1rem);
    font-weight: var(--details_buttons_confirmation_font_weight, normal);
    @media screen and (min-width: 960px) {
      width: 50%;
    }
  }

  &__box-title {
    clear: both;
    padding: 0.25rem 0 1rem;
    font-family: var(--details_headings_font_family, inherit);
    font-size: var(--details_headings_font_size, 1.25rem);
    font-weight: var(--details_headings_font_weight, bold);
    color: var(--details_headings_font_color, #0a3b74);
  }

  &__basket-total {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 1.5rem;
    padding: 1.5rem 0 0.5rem;
    border-top: 1px solid #55555555;
  }

  &__box-title--total {
    font-size: 1.5rem;
  }

  &__box-title--price {
    font-size: 1.5rem;
    font-family: var(--basket_price_font_family, inherit);
    font-weight: var(--basket_price_font_weight, bold);
    color: var(--basket_price_font_color, #236ca3);
  }

  &__basket {
    // outline: 1px solid blue;
    display: none;
    @media screen and (min-width: 960px) {
      display: block;
    }

    &--box-style {
      background: #ffffff;
      box-shadow: 0px 3px 6px #00000029;
      border: 1px solid #dfdfdf;
      padding: 1em 1.375rem;
      margin-bottom: 1rem;
    }
  }

  &__download-box {
    border: 2px solid #e5e4e9;
    margin-bottom: 1rem;
    border-radius: 0.5rem;
    padding: 1rem;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
  }

  &__download-box--active {
    border: 2px solid #236ca3;
  }

  &__download-body {
    h4 {
      font-size: 1rem;
      font-weight: bold;
    }
    p {
      font-size: 0.925rem;
      margin: 0;
    }
  }
}

.confirmation-image {
  height: 2.5rem;
  width: 2.5rem;
  display: block;
  margin-bottom: 1rem;
}

.underline {
  text-decoration-line: underline;
  cursor: pointer;
}

.account-created-box {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  width: auto;
  border: 2px solid #039420;
  color: #039420;
  font-weight: bold;
  border-radius: 0.25rem;
  padding: 0.5rem 3rem;
  .confirmation-image {
    margin: 0 0.5rem 0 0;
    width: 2rem;
    height: 2rem;
  }
}
</style>
